module.exports = __webpack_public_path__ + "img/receiveBg.ffd4f42f.png";